import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import { Link, useParams } from 'react-router-dom';
import { SingleBusinessData, UpdateBusiness } from '../../../../store/actions/new/businessAction';
import { useDispatch } from 'react-redux';

const UpdateBusinessInfo = ({ openModal, setOpen, type, onSubmitResponse, singleBusiness }) => {
    const [title, setTitle] = useState('');
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false); 
    const closeModal = () => setOpen(false);
    const inputRef = useRef(null);
    const { id } = useParams();
    const dispatch = useDispatch()
    const [formData, setFormData] = useState({
        id: id,
        columns: {
            name: '',
            tagLine: '',
            website: '',
        }
    });
    useEffect(() => {
        if (singleBusiness && Object.keys(singleBusiness).length > 0) {
            setFormData({
                id: id,
                columns: {
                    name: singleBusiness.name,
                    tagLine: singleBusiness.tagLine,
                    category: singleBusiness.category,
                    productService: singleBusiness.productService,
                    website: singleBusiness.website,

                    address: singleBusiness.address
                }
            });
        }
        else {
            dispatch(SingleBusinessData(id));
        }
    }, [id, singleBusiness]);

    useEffect(() => {
        if (openModal) {

        setTitle('');
        setError('')
          const timer = setTimeout(() => {
            inputRef.current?.focus();
          }, 100); 
    
          return () => clearTimeout(timer);
        }
      }, [openModal]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await dispatch(UpdateBusiness(formData));
        if(response.status >= 200 && response.status < 300){
            setOpen(false)
        }
    };
    const handleInputChange = (e, type = '') => {
        const value = e?.target ? e.target.value : e; 
        const name = e?.target ? e.target.name : 'country';
        
    
        if (type === 'category') {
            setFormData((prev) => ({
                ...prev,
                columns: {
                    ...prev.columns,
                    category: {
                        ...prev.columns.category,
                        name: value 
                    }
                }
            }));
        } else if (type === 'address') {
            setFormData((prev) => ({
                ...prev,
                columns: {
                    ...prev.columns,
                    address: {
                        ...prev.columns.address,
                        [name]: value 
                    }
                }
            }));
        } else {
            
            setFormData((prev) => ({
                ...prev,
                columns: {
                    ...prev.columns,
                    [name]: value 
                }
            }));
        }
    };

    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
                <div className="modal">
                    <div className="modal-header">
                        <h3>Update {type}</h3>
                        <Link className="close" onClick={closeModal}>
                          &times;
                        </Link>
                    </div>
                    <div className="modal-content">
                        <form className="modal-form-wrapper" onSubmit={handleSubmit}>
                            <div className="modal-flex">
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>Business Name</label>
                                        <input 
                                            className="sett-form-input" 
                                            name="name" 
                                            placeholder="Creative Solution" 
                                            value={formData.columns.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="sng-content-repeater">
                                    <div className="sng-content">
                                        <label>Tagline</label>
                                        <input 
                                            className="sett-form-input" 
                                            name="tagLine" 
                                            placeholder="e.g. Your innovation"
                                            value={formData.columns.tagLine}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="sng-content-repeater">
                                <div className="sng-content">
                                    <label>Website</label>
                                    <input 
                                        type="text" 
                                        className="sett-form-input" 
                                        name="website" 
                                        placeholder="e.g. https://example.com"
                                        value={formData.columns.website}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            {error && <p className="error">{error}</p>}
                            <div className="text-right">
                                 <button type="submit" className="btn btn-submit" disabled={isProcessing}>
                                    {isProcessing ? 'Processing...' : 'Update'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default UpdateBusinessInfo;